import React = require('react');
import { Formik, FormikProps } from 'formik';

import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';

import { Messages } from '../../codegen/Localize';
import { UserSettings } from '../services/resources/UserSettings';
import { UserSettingsStyle } from '../styles/UserSettingsStyle';
import _ = require('underscore');
import { FormikCheckbox } from '../../commonInfra/components/FormikCheckbox';
import { NotificationsSettingsProps } from './NotificationsSettings';
import { InlineCancelAndSaveButtons } from './UserSettingEditButtons';

export interface SubscriptionNotificationField {
    subscriptionNotificationEnabled: boolean;
}

function showButtons(formik: FormikProps<SubscriptionNotificationField>, subscriptionNotificationEnabled: boolean) {
    if (!formik.touched || !formik.isValid || formik.isSubmitting || _.isEqual(formik.values.subscriptionNotificationEnabled, subscriptionNotificationEnabled)) {
        return false;
    }
    return true;
}

export function SubscriptionNotification(props: NotificationsSettingsProps): JSX.Element {
    const [currentSubscriptionNotificationEnabled, setCurrentSubscriptionNotificationEnabled] = React.useState(false);

    async function handleSubmit(values: SubscriptionNotificationField) {
        UserSettings.updateSuspendedSubscriptionSetting(props.siteUser.id, values.subscriptionNotificationEnabled).then(() => {
            setCurrentSubscriptionNotificationEnabled(values.subscriptionNotificationEnabled);
            ToasterService.instance.pop({ type: ToastType.Success, text: Messages.settingsUpdateSuccess() });
        }).catch(() => {
            ToasterService.instance.pop({ type: ToastType.Error, text: Messages.settingsUpdateFailure() });
        });
    }

    React.useEffect(
        () => {
            UserSettings.getSuspendedSubscriptionSetting(props.serverUser.id)
                .then((result: boolean) => {
                    setCurrentSubscriptionNotificationEnabled(result);
                }).catch(() => { });
        },
        // This deps array was noncompliant before we enabled the lint rule. If you're here, please consider fixing it! See TFS 1257824
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []
    );

    return (
        <Formik
            initialValues={{ subscriptionNotificationEnabled: currentSubscriptionNotificationEnabled }}
            onSubmit={(values: SubscriptionNotificationField) => handleSubmit(values)}
            enableReinitialize={true}
        >
            {
                (formik: FormikProps<SubscriptionNotificationField>) => (
                    <form onSubmit={formik.handleSubmit}>
                        <table>
                            <tbody className={UserSettingsStyle.tbody}>
                                <tr data-tb-test-id="userSettings-subscription-notification">
                                    <td className={UserSettingsStyle.labelText}>
                                        {Messages.subscriptions()}
                                    </td>
                                    <td className={UserSettingsStyle.detailsValue}>
                                        {Messages.subscriptionSuspendedNotificationUserSettingDetail()}
                                    </td>
                                </tr>
                                <tr>
                                    <td className={UserSettingsStyle.labelText} />
                                    <td className={UserSettingsStyle.detailsValue}>
                                        <FormikCheckbox
                                            containerStyle={{ marginLeft: 0 }}
                                            testId='Subscription-Notification-Enabled'
                                            name={'subscriptionNotificationEnabled'}
                                            disabled={props.userHasNoSiteId}
                                            label={Messages.subscriptionSuspendedNotificationUserSettingEnable()} />
                                    </td>
                                </tr>
                                {
                                    showButtons(formik, currentSubscriptionNotificationEnabled) &&
                                    <InlineCancelAndSaveButtons
                                        testId={'subscription-notification'}
                                        formik={formik}
                                    />
                                }
                            </tbody>
                        </table>
                    </form>
                )
            }
        </Formik>
    );
}